import uuidv4 from 'uuid/v4';
import { UPDATE_DISPLAYED_AKTAS, UPDATE_DISPLAYED_MODAL_AKTAS } from '../mutation_types';
import { GET_AKTAS_LIST, GET_MODAL_AKTAS_LIST } from '../action_types';
import { getFolders, searchGlobal } from '@/http/api';


export const state = {
    displayedAktas: [],
    // displayedModalAktas: []
};

export const getters = {
};

export const mutations = {
    [UPDATE_DISPLAYED_AKTAS](state, payload) {
        const newDisplayed = payload.aktaObjects;
        state.displayedAktas = newDisplayed;
    }
    // [UPDATE_DISPLAYED_MODAL_AKTAS](state, payload) {
    //     const newDisplayed = payload.aktaObjects;
    //     state.displayedModalAktas = newDisplayed;
    // }
};

export const actions = {
    [GET_AKTAS_LIST]({ commit }, payload) {
        return new Promise((resolve, reject) => {
            // const options = {
            //     params: {
            //         ...payload.options,
            //         isInfo: false
            //     }
            // }
            const options = payload.options;
            searchGlobal(options).then(res => {
                console.log('AKTASREZ', res);
                commit({
                    type: UPDATE_DISPLAYED_AKTAS,
                    aktaObjects: res.data.result
                })
                resolve(res);
            });
        })
    }
    // [GET_MODAL_AKTAS_LIST]({ commit }, payload) {
    //     return new Promise((resolve, reject) => {
    //         const options = {
    //             params: {
    //                 ...payload.options,
    //                 isInfo: false
    //             }
    //         }
    //         getFolders(options).then(res => {
    //             console.log('AKTASREZ', res);
    //             commit({
    //                 type: UPDATE_DISPLAYED_AKTAS,
    //                 aktaObjects: res.data.data
    //             })
    //             resolve(res);
    //         });
    //     })
    // }
};

export default {
    state,
    getters,
    mutations,
    actions
}